/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { ProjectFundingReferenceFundingSubstreamDTO } from './ProjectFundingReferenceFundingSubstreamDTO';
import {
    ProjectFundingReferenceFundingSubstreamDTOFromJSON,
    ProjectFundingReferenceFundingSubstreamDTOFromJSONTyped,
    ProjectFundingReferenceFundingSubstreamDTOToJSON,
    ProjectFundingReferenceFundingSubstreamDTOToJSONTyped,
} from './ProjectFundingReferenceFundingSubstreamDTO';
import type { ProjectFundingReferenceFundingStreamDTO } from './ProjectFundingReferenceFundingStreamDTO';
import {
    ProjectFundingReferenceFundingStreamDTOFromJSON,
    ProjectFundingReferenceFundingStreamDTOFromJSONTyped,
    ProjectFundingReferenceFundingStreamDTOToJSON,
    ProjectFundingReferenceFundingStreamDTOToJSONTyped,
} from './ProjectFundingReferenceFundingStreamDTO';
import type { ProjectFundingReferenceExternalIdentifierDTO } from './ProjectFundingReferenceExternalIdentifierDTO';
import {
    ProjectFundingReferenceExternalIdentifierDTOFromJSON,
    ProjectFundingReferenceExternalIdentifierDTOFromJSONTyped,
    ProjectFundingReferenceExternalIdentifierDTOToJSON,
    ProjectFundingReferenceExternalIdentifierDTOToJSONTyped,
} from './ProjectFundingReferenceExternalIdentifierDTO';

/**
 * 
 * @export
 * @interface ProjectFundingReferenceDTO
 */
export interface ProjectFundingReferenceDTO  {
    /**
     * 
     * @type {number}
     * @memberof ProjectFundingReferenceDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectFundingReferenceDTO
     */
    funderName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectFundingReferenceDTO
     */
    projectAcronym?: string;
    /**
     * 
     * @type {Array<ProjectFundingReferenceExternalIdentifierDTO>}
     * @memberof ProjectFundingReferenceDTO
     */
    externalProjectIdentifiers?: Array<ProjectFundingReferenceExternalIdentifierDTO>;
    /**
     * 
     * @type {string}
     * @memberof ProjectFundingReferenceDTO
     */
    projectTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectFundingReferenceDTO
     */
    projectUri?: string;
    /**
     * 
     * @type {Array<ProjectFundingReferenceFundingStreamDTO>}
     * @memberof ProjectFundingReferenceDTO
     */
    projectFundingReferenceFundingStreams?: Array<ProjectFundingReferenceFundingStreamDTO>;
    /**
     * 
     * @type {Array<ProjectFundingReferenceFundingSubstreamDTO>}
     * @memberof ProjectFundingReferenceDTO
     */
    projectFundingReferenceFundingSubstreams?: Array<ProjectFundingReferenceFundingSubstreamDTO>;
}

/**
 * Check if a given object implements the ProjectFundingReferenceDTO interface.
 */
export function instanceOfProjectFundingReferenceDTO(value: object): value is ProjectFundingReferenceDTO {
    return true;
}

export function ProjectFundingReferenceDTOFromJSON(json: any): ProjectFundingReferenceDTO {
    return ProjectFundingReferenceDTOFromJSONTyped(json, false);
}

export function ProjectFundingReferenceDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectFundingReferenceDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'funderName': json['funderName'] == null ? undefined : json['funderName'],
                  'projectAcronym': json['projectAcronym'] == null ? undefined : json['projectAcronym'],
              'externalProjectIdentifiers': json['externalProjectIdentifiers'] == null ? undefined : ((json['externalProjectIdentifiers'] as Array<any>).map(ProjectFundingReferenceExternalIdentifierDTOFromJSON)),
                  'projectTitle': json['projectTitle'] == null ? undefined : json['projectTitle'],
                  'projectUri': json['projectUri'] == null ? undefined : json['projectUri'],
              'projectFundingReferenceFundingStreams': json['projectFundingReferenceFundingStreams'] == null ? undefined : ((json['projectFundingReferenceFundingStreams'] as Array<any>).map(ProjectFundingReferenceFundingStreamDTOFromJSON)),
              'projectFundingReferenceFundingSubstreams': json['projectFundingReferenceFundingSubstreams'] == null ? undefined : ((json['projectFundingReferenceFundingSubstreams'] as Array<any>).map(ProjectFundingReferenceFundingSubstreamDTOFromJSON)),
    };
}

export function ProjectFundingReferenceDTOToJSON(json: any): ProjectFundingReferenceDTO {
    return ProjectFundingReferenceDTOToJSONTyped(json, false);
}

export function ProjectFundingReferenceDTOToJSONTyped(value?: ProjectFundingReferenceDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'funderName': value['funderName'],
        'projectAcronym': value['projectAcronym'],
        'externalProjectIdentifiers': value['externalProjectIdentifiers'] == null? value['externalProjectIdentifiers']: (value['externalProjectIdentifiers'] as Array<any>).map(ProjectFundingReferenceExternalIdentifierDTOToJSON),
        'projectTitle': value['projectTitle'],
        'projectUri': value['projectUri'],
        'projectFundingReferenceFundingStreams': value['projectFundingReferenceFundingStreams'] == null? value['projectFundingReferenceFundingStreams']: (value['projectFundingReferenceFundingStreams'] as Array<any>).map(ProjectFundingReferenceFundingStreamDTOToJSON),
        'projectFundingReferenceFundingSubstreams': value['projectFundingReferenceFundingSubstreams'] == null? value['projectFundingReferenceFundingSubstreams']: (value['projectFundingReferenceFundingSubstreams'] as Array<any>).map(ProjectFundingReferenceFundingSubstreamDTOToJSON),
    };
}


